<template>
  <div class="settings-org-reference-toolbar">
    <div class="settings-org-reference-toolbar__meta">
      <span class="settings-org-reference-toolbar__count">{{ countLabel }}</span>
      <SettingsShowInactiveToggle
        v-if="showInactiveToggle"
        :model-value="showInactive"
        :input-id="inactiveInputId"
        :disabled="loading"
        @update:model-value="$emit('update:showInactive', $event)"
      />
    </div>
    <IconField class="settings-org-reference-toolbar__search">
      <InputIcon class="pi pi-search" />
      <InputText
        :model-value="searchQuery"
        :placeholder="searchPlaceholder"
        class="w-full rounded-xl"
        @update:model-value="$emit('update:searchQuery', $event)"
        @keydown.enter.prevent="$emit('submit-search')"
        @keydown.esc.prevent="clearSearch"
      />
    </IconField>
  </div>
</template>

<script setup>
import InputText from 'primevue/inputtext';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import SettingsShowInactiveToggle from './SettingsShowInactiveToggle.vue';

defineOptions({ name: 'SettingsOrgReferenceToolbar' });

defineProps({
  countLabel: {
    type: String,
    required: true,
  },
  showInactive: {
    type: Boolean,
    default: false,
  },
  searchQuery: {
    type: String,
    default: '',
  },
  searchPlaceholder: {
    type: String,
    default: 'Search...',
  },
  inactiveInputId: {
    type: String,
    default: 'settings-org-inactive',
  },
  showInactiveToggle: {
    type: Boolean,
    default: true,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:showInactive', 'update:searchQuery', 'submit-search']);

function clearSearch() {
  emit('update:searchQuery', '');
  emit('submit-search');
}
</script>

<style scoped>
.settings-org-reference-toolbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.settings-org-reference-toolbar__meta {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
  min-width: 0;
}

.settings-org-reference-toolbar__count {
  font-size: 0.875rem;
  color: var(--crc-text-muted, var(--text-color-secondary));
}

.settings-org-reference-toolbar__search {
  width: min(100%, 18rem);
  flex-shrink: 0;
  margin-left: auto;
}
</style>
